import React from 'react';
import { Activity, Beaker, Leaf } from 'lucide-react';
export function ScienceSection() {
  const points = [{
    icon: <Activity className="w-8 h-8 text-gold" data-id="element-443" />,
    title: 'Ritual Fisiológico',
    desc: 'Activá el Nervio Vago para reducir el cortisol. El estrés crónico paraliza tu digestión; aprenderás a "encender" el modo de relajación y digestión en minutos.'
  }, {
    icon: <Beaker className="w-8 h-8 text-gold" data-id="element-444" />,
    title: 'El Estudio de Stanford 2021',
    desc: 'Descubrí por qué los alimentos fermentados superan a la fibra para diversificar tu microbiota y reducir los marcadores de inflamación sistémica.'
  }, {
    icon: <Leaf className="w-8 h-8 text-gold" data-id="element-445" />,
    title: 'La Ciencia de las 12 Hierbas',
    desc: 'Utilizá compuestos naturales que bloquean los marcadores de inflamación NF-kB, actuando como un "ibuprofeno natural" para tu intestino.'
  }];
  return <section className="py-14 bg-sage text-cream" data-id="element-446">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-447">
        <div className="max-w-4xl mx-auto text-center mb-10" data-id="element-448">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6 text-white" data-id="element-449">
            Más que una dieta, un Biohacking para tu Microbiota.
          </h2>
          <p className="text-xl text-cream/80 font-sans" data-id="element-450">
            Basado en ciencia real para mujeres reales. No es magia, es biología
            aplicada.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-451">
          {points.map((point, idx) => <div key={idx} className="bg-cream rounded-2xl p-8 border border-gold/20 shadow-xl hover:-translate-y-1 transition-transform duration-300" data-id="element-452">
              <div className="bg-sage/5 w-16 h-16 rounded-full flex items-center justify-center mb-6 border border-sage/10" data-id="element-453">
                {point.icon}
              </div>
              <h3 className="text-xl font-serif font-bold text-sage mb-4" data-id="element-454">
                {point.title}
              </h3>
              <p className="text-sage/80 leading-relaxed" data-id="element-455">{point.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}